import { getElement } from "./utils/getElement";
import { getPosts } from "./utils/getData";
import { renderPosts } from "./utils/getData";

const initLoadMorePosts = () => {
    const loadMoreBtn = getElement('.js-load-more-posts');
    const postsContainer = getElement('.js-posts');
    const { posts_per_page } = wpstatsHelper;

    if (!loadMoreBtn || !postsContainer) {
        return;
    }

    let page = 1;

    loadMoreBtn.addEventListener('click', async (e) => {
        e.preventDefault();

        const postType = loadMoreBtn.getAttribute('data-post-type');
        const taxonomy = loadMoreBtn.getAttribute('data-taxonomy');
        const term = loadMoreBtn.getAttribute('data-term');
        const maxPage = loadMoreBtn.getAttribute('data-max-page');

        loadMoreBtn.disabled = true;
        page++;

        try {
            const posts = await getPosts(page, postType, taxonomy, term);

            if (posts.length > 0) {
                renderPosts(posts, postType, postsContainer);

                if (page >= parseInt(maxPage)) {
                    loadMoreBtn.style.display = 'none';
                } else {
                    loadMoreBtn.disabled = false;
                }
            } else {
                loadMoreBtn.style.display = 'none';
            }
        } catch (error) {
            console.error('Error loading more posts:', error);
            loadMoreBtn.style.display = 'none';
        }
    });
};

export { initLoadMorePosts };
